"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const field_list_1 = __importDefault(require("../../field-list"));
const delete_icon_1 = __importDefault(require("./delete-icon"));
const styles_1 = require("../../../styles");
const FieldGroup = ({ label, fields, onRemove, valueIndex, enableRemove }) => (react_1.default.createElement(styles_1.FieldListItemStyle, null,
    react_1.default.createElement(styles_1.FieldListHeader, null,
        react_1.default.createElement(delete_icon_1.default, { entityName: label, onRemove: onRemove, valueIndex: valueIndex, enableRemove: enableRemove })),
    react_1.default.createElement(field_list_1.default, { fields: fields })));
exports.default = FieldGroup;
//# sourceMappingURL=field-group.js.map